import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiResponse } from "../shareModule/models/common.model";

@Injectable({
  providedIn: "root",
})
export class BusinessService {
  private baseUrl = environment.baseUrlAdmin;

  constructor(private http: HttpClient) {}

  public addJoinBiz(payload: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.baseUrl}addJoinBiz`, payload);
  }

  public deleteBiz(id: number) {
    return this.http.delete(`${this.baseUrl}deleteBiz/${id}`);
  }

  public getAllBiz(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllBiz`);
  }
}
